module.exports = __webpack_public_path__ + "img/resized-20160625-130533.2473356a.jpg";